import { render } from "./EditUserRestrictionsModal.vue?vue&type=template&id=0deec06c"
import script from "./EditUserRestrictionsModal.vue?vue&type=script&lang=js"
export * from "./EditUserRestrictionsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/EditUserRestrictionsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0deec06c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0deec06c', __exports__)) {
    api.reload('0deec06c', __exports__)
  }
  
  module.hot.accept("./EditUserRestrictionsModal.vue?vue&type=template&id=0deec06c", () => {
    api.rerender('0deec06c', render)
  })

}


export default __exports__